import {
  COLORS,
  WIDGET_CLASS,
  EMBED_PATH,
  ATTR,
  DEFAULT_PRODUCT,
  getProduct,
  type Colors,
  type ProductKey,
} from "../config/widget";

export interface WidgetConfig {
  product: ProductKey;
  hideTitle: boolean;
  partnerId: string;
  b: string;
  chan: string;
  hidePromo: boolean;
  companies: string[];
  colors: Colors;
}

/** На формах продуктов вроде ПКаско фильтр по СК не применяется — выбор туда не уходит. */
function effectiveCompanies(config: WidgetConfig): string[] {
  return getProduct(config.product).supportsCompanies ? config.companies : [];
}

function hex(value: string): string {
  const v = value.trim();
  if (!v) return "";
  return v.startsWith("#") ? v.slice(1) : v;
}

function escapeAttr(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

export function buildThemeColors(colors: Colors): Record<string, string> {
  const result: Record<string, string> = {};
  for (const color of COLORS) {
    const value = hex(colors[color.key]);
    if (value) result[color.queryParam] = `#${value}`;
  }
  return result;
}

export function buildWidgetAttrs(config: WidgetConfig): Record<string, string> {
  const attrs: Record<string, string> = {
    [ATTR.partner]: config.partnerId,
  };

  for (const color of COLORS) {
    const value = hex(config.colors[color.key]);
    if (value) attrs[color.dataAttr] = `#${value}`;
  }

  if (config.product !== DEFAULT_PRODUCT) attrs[ATTR.product] = config.product;
  if (config.b) attrs[ATTR.b] = config.b;
  if (config.chan.trim()) attrs[ATTR.chan] = config.chan.trim();
  if (config.hidePromo) attrs[ATTR.hidePromo] = "true";
  if (config.hideTitle) attrs[ATTR.hideTitle] = "true";
  const companies = effectiveCompanies(config);
  if (companies.length) attrs[ATTR.companies] = companies.join(",");

  return attrs;
}

export function buildSnippet(embedHost: string, config: WidgetConfig): string {
  const attrs = [
    `class="${WIDGET_CLASS}"`,
    `${ATTR.partner}="${escapeAttr(config.partnerId)}"`,
  ];

  for (const color of COLORS) {
    const value = hex(config.colors[color.key]);
    if (value) attrs.push(`${color.dataAttr}="#${value}"`);
  }

  if (config.product !== DEFAULT_PRODUCT) {
    attrs.push(`${ATTR.product}="${escapeAttr(config.product)}"`);
  }
  if (config.b) attrs.push(`${ATTR.b}="${escapeAttr(config.b)}"`);
  if (config.chan.trim()) attrs.push(`${ATTR.chan}="${escapeAttr(config.chan.trim())}"`);
  if (config.hidePromo) attrs.push(`${ATTR.hidePromo}="true"`);
  if (config.hideTitle) attrs.push(`${ATTR.hideTitle}="true"`);
  const companies = effectiveCompanies(config);
  if (companies.length) {
    attrs.push(`${ATTR.companies}="${escapeAttr(companies.join(","))}"`);
  }

  const div = `<div ${attrs.join("\n     ")}></div>`;
  const script = `<script src="${embedHost}${EMBED_PATH}" async></script>`;
  return `${div}\n${script}`;
}
